<template>
  <div>
    <PageHeader link-name="Назад" link-path="ProductsList" page-name="Модерирование Обьявлений">
      <template>
        <div class="title-bar__button-wrapper">
          <el-button type="danger" @click="transferToContractor">
            Перетворити оголошення у виконавця
          </el-button>
          <router-link class="button-wrapper-link" :to="{name: 'ProductsList'}">
            <el-button type="gray">
              <i class="fas fa-list" /> Список
            </el-button>
          </router-link>

          <!--          <router-link class="button-wrapper-link" :to="{name: 'LogsList', params: {id: product && product.id, subject: 'product'}}">-->
          <!--            <el-button type="info">-->
          <!--              <i class="fas fa-info-circle" /> Действия над Обьявлением-->
          <!--            </el-button>-->
          <!--          </router-link>-->

          <el-button :loading="saving" type="success" @click="onSaveProduct">
            Сохранить
          </el-button>
        </div>
      </template>
    </PageHeader>
    <MainPanel v-loading="loading || saving" class="panel--mb">
      <div v-if="product" class="form-container">
        <div class="form-columns">
          <div class="form-column">
            <div class="form-field">
              <div class="field-label">
                Название (UA)
              </div>
              <el-input v-model="form.name" />
            </div>

            <div class="form-field">
              <div class="field-label">
                Название (RU)
              </div>
              <el-input v-model="form.name_ru" />
            </div>

            <div class="form-field">
              <div class="field-label">
                Характеристики
              </div>
              <el-input v-model="form.characteristic" />
            </div>

            <div class="form-field">
              <div class="field-label">
                Описание (UA)
              </div>
              <Redactor
                v-model="form.description"
                class="editable-text__editor"
              />
            </div>

            <div class="form-field">
              <div class="field-label">
                Описание (RU)
              </div>
              <Redactor
                v-model="form.description_ru"
                class="editable-text__editor"
              />
            </div>

            <div class="form-field">
              <div class="field-label">
                Город
              </div>
              <el-select
                v-if="cityOptions && cityOptions.length > 0"
                v-model="selectedCityId"
                filterable
                placeholder="Введите город"
                remote
                :remote-method="getCity"
                reserve-keyword
                style="width: 100%"
                @change="selectedCityChange"
              >
                <el-option
                  v-for="item in cityOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>

            <div class="form-field">
              <div class="field-label">
                Цена
              </div>
              <el-input v-model="form.price" />
            </div>

            <div class="form-field">
              <div class="field-label">
                Ссылка на видео
              </div>
              <el-input v-model="form.video_link" />
            </div>
          </div>

          <div class="form-column">
            <div class="form-field">
              <div class="field-label">
                <strong>Топ статус</strong>
              </div>
              <el-switch
                active-color="#13ce66"
                :value="product.is_top"
                @change="changeTopStatus"
              />
            </div>

            <div class="form-field">
              <div class="field-label">
                <strong>Мы рекомендуем</strong>
              </div>
              <el-switch
                active-color="#13ce66"
                :value="product.is_recommended"
                @change="changeRecommendedStatus"
              />
            </div>

            <div class="form-field">
              <div class="field-label">
                <strong>Позиция</strong>
              </div>
              <el-input
                v-model="product.position"
                v-debounce:700ms="changePosition"
                class="position-input"
                style="width: 120px"
                type="number"
              />
            </div>

            <div class="form-field">
              <div class="field-label">
                Категория
              </div>
              <el-select
                v-model="form.category_id"
                placeholder="Выберите категорию"
                style="width: 100%"
                value-key="id"
                @change="onCategoryChange"
              >
                <el-option-group
                  v-for="group in categories"
                  :key="group.id"
                  :label="group.name"
                >
                  <el-option
                    v-for="category in group.children"
                    :key="category.id"
                    :label="category.name"
                    :value="category.id"
                  />
                </el-option-group>
              </el-select>
            </div>

            <div class="form-field">
              <div class="field-label">
                Атрибуты
              </div>
              <el-select
                v-model="form.attributes"
                clearable
                filterable
                multiple
                placeholder="Выберите атрибуты"
                style="width: 100%"
                @change="onAttributeChange"
              >
                <el-option
                  v-for="item in attributes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>

            <div class="form-field">
              <div class="field-label">
                Тематические страницы
              </div>
              <el-select
                v-model="form.topics"
                multiple
                placeholder="Выберите тематические страницы"
                style="width: 100%"
                value-key="id"
                @change="onTopicsChange"
              >
                <el-option
                  v-for="topic in topics"
                  :key="topic.id"
                  :label="topic.title"
                  :value="topic.id"
                />
              </el-select>
            </div>
          </div>
        </div>

        <div class="form-field full-width">
          <div class="field-label">
            Изображения
          </div>
          <el-button
            style="margin-bottom: 10px; width: 140px"
            type="primary"
            @click="toggleEditMode"
          >
            Редагувати
          </el-button>
          <ImagesEdit
            :edit-mode="editMode"
            :images="form.images"
            @status-change="addImage"
          />
        </div>
      </div>
    </MainPanel>

    <MainPanel v-loading="loading">
      <div class="comparing-columns-heading" style="margin-bottom: 30px;">
        Пользователь
      </div>
      <table v-if="product" class="key-values-table">
        <tr v-if="product.frontend_url">
          <td>Ссылка на объявление</td>
          <td>
            <a :href="product.frontend_url" target="_blank">
              {{ product.frontend_url }}
            </a>
          </td>
        </tr>

        <tr v-else>
          <td>id</td>
          <td>{{ product.id }}</td>
        </tr>

        <tr>
          <td>Админ. статус</td>
          <td>
            <el-dropdown
              class="btn-item"
              trigger="click"
              @command="(command) => changeStatus(command)"
            >
              <span class="el-dropdown-link">
                {{ product.admin_status || 'Выберите статус' }}
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(value, key) in adminStatuses"
                  :key="key"
                  :command="value"
                >
                  {{ value }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </td>
        </tr>

        <tr v-if="product.created_at">
          <td>Дата создания</td>
          <td>{{ product.created_at }}</td>
        </tr>

        <tr v-if="product.price">
          <td>Цена</td>
          <td v-if="product.is_price_from">от {{ product.price }} {{ getCurrencyByKey(product.currency) }}</td>
          <td v-else>{{ product.price }} {{ getCurrencyByKey(product.currency) }}</td>
        </tr>

        <tr v-else>
          <td>Цена</td>
          <td>Договорная</td>
        </tr>

        <tr v-if="product.condition">
          <td>Состояние</td>
          <td>{{ getProductConditionByKey(product.condition) }}</td>
        </tr>

        <tr v-if="product.contacts.phone">
          <td>Номер телефона</td>
          <td>{{ product.contacts.phone }}</td>
        </tr>

        <tr v-if="product.city">
          <td>Населённый пункт</td>
          <td>{{ product.city.name }}</td>
        </tr>

        <tr v-if="product.city">
          <td>Область</td>
          <td>{{ product.city.region_name }}</td>
        </tr>

        <tr v-if="product.complaints_count">
          <td>Количество жалоб</td>
          <td>{{ product.complaints_count }}</td>
        </tr>

        <tr>
          <td>Пользователь</td>
          <td>
            <UserCard :user="product.user" />
          </td>
        </tr>

        <tr v-if="product.city">
          <td>Статус</td>
          <td>
            <el-tag
              class="type-tag"
              size="small"
              :type="getStatusTagType(product.state)"
            >
              {{ product.state.replace('_', ' ') }}
            </el-tag>
          </td>
        </tr>

        <tr>
          <td>Подтверждение</td>
          <td>
            <el-button-group>
              <el-button
                :disabled="!product.actions.discard"
                size="small"
                :type="product.state === 'DISCARDED' ? 'danger' : ''"
                @click="$refs.checkReasonModal.open()"
              >
                Нет
              </el-button>
              <el-button
                :disabled="!product.actions.approve"
                size="small"
                :type="product.state === 'CHECKED' ? 'success' : ''"
                @click="onApproveProduct"
              >
                Да
              </el-button>
            </el-button-group>
          </td>
        </tr>
        <tr>
          <td />
          <td>
            <el-button @click="deleteThisProduct">Удалить</el-button>
          </td>
        </tr>
      </table>
    </MainPanel>

    <CheckReasonModal ref="checkReasonModal" @check="onDiscardProduct" />
    <el-dialog
      :before-close="handleClose"
      class="text-center custom-dialog"
      title="Увага!"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="dialog-content">
        <p class="message">{{ contractor_message }}</p>

        <a class="link" :href="contractor_frontend_url" target="_blank">Профіль виконавця на сайті</a>

        <a class="link" :href="contractor_admin_url" target="_blank">Профіль виконавця в адмінці</a>

        <el-button
          v-if="contractor_change_content"
          class="replace-button"
          type="danger"
          @click="replaceContent"
        >
          Замінити контент
        </el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MainPanel from '@/components/common/MainPanel'
import { mapActions, mapGetters, mapState } from 'vuex'
import CheckReasonModal from '@/components/products/CheckReasonModal'
import UserCard from '@/components/user-card/UserCard'
import PageHeader from '@/components/common/PageHeader'
import ImagesEdit from '@/components/common/ImagesEdit.vue'
import Redactor from '@/components/common/WysiwygRedactor.vue'

export default {
  metaInfo: {
    title: 'Модерирование обьявлений',
  },
  components: { Redactor, ImagesEdit, UserCard, PageHeader, MainPanel, CheckReasonModal },
  data () {
    return {
      productId: null,
      product: null,
      loading: false,
      saving: false,
      timer: null,
      form: {
        name: '',
        name_ru: '',
        description: '',
        description_ru: '',
        categories: [],
        additional_categories: [],
        category_id: '',
        characteristic: '',
        video_link: '',
        topics: [],
        attributes: [],
        price: '',
      },
      contractor_frontend_url: '#',
      contractor_admin_url: '#',
      contractor_message: 'Контент виконавця був успішно замінений контентом оголошення. Оголошення видалено',
      contractor_change_content: false,
      additionalCategory: '',
      listOffersForWishes: [],
      dialogVisible: false,
      localAdminStatuses: { 'DEFAULT': 'Без статусу' },
      adminStatusesLoaded: false,
      editMode: false,
      cityOptions: [],
      selectedCityId: null,
      attributes: [],
    }
  },
  computed: {
    ...mapGetters('value-objects', [
      'getProductConditionByKey',
      'getStatusTagType',
      'getCurrencyByKey',
    ]),
    ...mapGetters('products', [
      'productAdminStatusesTransformed',
    ]),
    ...mapState('wishes/categories', [
      'categories',
    ]),
    ...mapState('topics', [
      'topics',
    ]),

    adminStatuses () {
      return this.localAdminStatuses.reduce((acc, status) => {
        acc[status.key] = status.label
        return acc
      }, {})
    },
  },
  async created () {
    this.productId = this.$route.params.id
    await this.loadAdminStatuses()
    try {
      try {
        await this.takeMutex(this.productId)
      } catch (e) {
        this.$alert('Это обьявление сейчас редактируется дргуим пользователем. Попробуйте позже')

        throw e
      }

      await Promise.all([
        this.getCities(),
        this.getProduct(),
        this.fetchProductConditions(),
        this.fetchCurrencies(),
        this.fetchCategories(),
        this.getAllTopics(),
      ])
      this.fillForm()
      this.attributes = await this.getAttributesByCategoryId(this.form.category_id)
      this.setMutexLoop()
    } catch (e) {
      this.$router.back()
    }
    if (this.product.category) {
      this.form.category_id = await this.product.category.id
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    try {
      this.leaveMutex(this.productId)
    } catch (e) {

    }
  },
  methods: {
    ...mapActions('products', ['fetchProduct',
      'fetchProductAdminStatuses',
      'approveProduct',
      'discardProduct',
      'takeMutex',
      'leaveMutex',
      'updateProduct',
      'deleteProduct',
      'transferProductToContractor',
      'changeContractorContent',
      'saveAdminStatus',
      'changeProductTopStatus',
      'changeProductPosition',
      'changeProductRecommendStatus',
      'saveProductCity',
      'saveProductTopics',
      'saveAttributes',
    ]),
    ...mapActions('offers', [
      'fetchOffersForWishes',
    ]),
    ...mapActions('value-objects', [
      'fetchProductConditions',
      'fetchCurrencies',
    ]),
    ...mapActions('cities', [
      'fetchCities', 'preloadCities',
    ]),
    ...mapActions('wishes/categories', ['fetchCategories', 'getAttributesByCategoryId']),
    ...mapActions('topics', ['getAllTopics']),

    async loadAdminStatuses () {
      if (!this.adminStatusesLoaded) {
        await this.fetchProductAdminStatuses()
        this.localAdminStatuses = [
          { key: 'DEFAULT', label: 'Без статусу' },
          ...this.productAdminStatusesTransformed,
        ]
        this.adminStatusesLoaded = true
      }
    },
    async getProduct () {
      this.product = await this.fetchProduct(this.productId)

      const city = this.product.city
      this.selectedCityId = city?.id || null

      const cityExists = this.cityOptions.some((c) => c.id === city?.id)

      if (city && !cityExists) {
        await this.getCity(city.name)
        const stillMissing = !this.cityOptions.some((c) => c.id === city.id)
        if (stillMissing) {
          this.cityOptions.unshift(city)
        }
      }
    },
    async onApproveProduct () {
      try {
        await this.approveProduct(this.product.id)
        await this.getProduct()
      } catch (e) {
        this.$message.error(e.response.data.message)
      }
    },
    async onDiscardProduct (form) {
      await this.discardProduct({
        id: this.product.id,
        form,
      })
      await this.getProduct()
    },
    async onSaveProduct () {
      this.saving = true
      try {
        await this.updateProduct({
          id: this.product.id,
          form: this.form,
        })
        if (this.form.attributes.length) {
          await this.saveAttributes({
            productId: this.productId,
            attributes: this.form.attributes,
          })
        }
        await this.getProduct()
        this.$message.success('Обьявление успешно сохранено')
      } catch (e) {
        this.$message.error(e.response.data.message)
      } finally {
        this.saving = false
      }
    },
    fillForm () {
      this.form.name = this.product.name
      this.form.name_ru = this.product.name_ru || ''
      this.form.description = this.product.description
      this.form.description_ru = this.product.description_ru || ''
      this.form.price = this.product.price
      this.form.characteristic = this.product.characteristic
      this.form.images = this.product.images
      this.form.video_link = this.product.video_link
      if (this.product.category) {
        this.form.category_id = this.product.category.id
      }
      if (this.product.categories_path.length === 0) return
      this.form.category = this.product.categories_path[this.product.categories_path.length - 1].id
      this.form.topics = this.product.topics ? this.product.topics.map(topic => topic.id) : []
      this.form.attributes = this.product.attributes ? this.product.attributes.map(attribute => attribute.id) : []
    },
    setMutexLoop () {
      this.timer = setInterval(() => {
        this.takeMutex(this.product.id)
      }, 60000)
    },
    async onCategoryChange () {
      this.form.attributes = [];
      this.attributes = await this.getAttributesByCategoryId(this.form.category_id)
    },
    async deleteThisProduct () {
      let confirmation = false
      try {
        confirmation = await this.$confirm('Вы дейсвтительно хотите удалить обьявление? Будут удалены также все предложения.', {
          cancelButtonText: 'Нет',
          confirmButtonText: 'Да',
          type: 'warning',
          center: true,
        })
      } catch (e) {
      }

      if (!confirmation) {
        return
      }

      try {
        await this.deleteProduct(this.product.id)
        this.$message.success('Обьявление успешно удалено')
        await this.$router.push({ name: 'WishesList' })
      } catch (e) {
        this.$message.error('Не получилось удалить обьявление.')
      }
    },
    addAdditionalCategory () {
      if (!this.additionalCategory) {
        this.$notify.error({
          title: 'Ошибка',
          message: 'Нужно выбрать Категорию',
        })
        return
      }
      this.form.additional_categories.push(this.additionalCategory[this.additionalCategory.length - 1])
      this.additionalCategory = ''
    },

    async transferToContractor () {
      if (!this.product.category) {
        this.$message.error('Нужно выбрать Категорию')
        return
      }
      let confirmation = false
      try {
        confirmation = await this.$confirm('Ви впевнені, що хочете створити сторінку виконавця на основі оголошення у профілі автора оголошення? Після створення сторінки виконавця, оголошення буде видалено автоматично!', {
          cancelButtonText: 'Ні',
          confirmButtonText: 'Так',
          type: 'warning',
          center: true,
        })
      } catch (e) {
      }
      if (!confirmation) {
        return
      }
      try {
        let result = await this.transferProductToContractor(this.product.id)
        if (result.status === 'ok') {
          this.contractor_admin_url = result.admin_url
          this.contractor_frontend_url = result.frontend_url
          this.contractor_message = result.message
          this.contractor_change_content = result.contractor_change_content
          this.dialogVisible = true
        } else {
          this.$message.error(result.message)
        }
      } catch (e) {
        console.log(e)
        this.$message.error('Не вдалося перетворити оголошення у виконавця')
      }
    },
    handleClose () {
      this.dialogVisible = false
      this.$router.push({ name: 'ProductsList' })
    },
    async replaceContent () {
      let confirmation = false
      try {
        confirmation = await this.$confirm('Ви впевнені, що хочете замінити контент існуючого користувача на контент оголошення?', {
          cancelButtonText: 'Ні',
          confirmButtonText: 'Так',
          type: 'warning',
          center: true,
        })
      } catch (e) {
      }
      if (!confirmation) {
        return
      }
      try {
        let result = await this.changeContractorContent(this.product.id)
        if (result.status === 'ok') {
          this.contractor_admin_url = result.admin_url
          this.contractor_frontend_url = result.frontend_url
          this.contractor_message = result.message
          this.contractor_change_content = result.contractor_change_content
          this.dialogVisible = true
        } else {
          this.$message.error(result.message)
        }
      } catch (e) {
        console.log(e)
        this.$message.error('Не вдалося перетворити оголошення у виконавця')
      }
    },
    changeStatus (value) {
      if (value === 'Без статусу') {
        value = null
      }
      this.saveAdminStatus({ id: this.product.id, status: value })
        .then(() => {
          this.product.admin_status = value
          this.$message({
            message: 'Статус успешно обновлен',
            type: 'success',
          })
        })
        .catch(error => {
          console.error('Ошибка при обновлении статуса:', error)
          this.$message({
            message: 'Ошибка при обновлении статуса',
            type: 'error',
          })
        })
    },

    async changeTopStatus (val) {
      this.product.is_top = val

      try {
        await this.changeProductTopStatus({ id: this.product.id, params: { is_top: val } })
        await this.$message.success('Статус успешно изменен')
      } catch (e) {
        await this.$message.error('Статус изменить не удалось')
        this.product.is_top = !val
      }
    },

    async changeRecommendedStatus (val) {
      this.product.is_recommended = val

      try {
        await this.changeProductRecommendStatus({ id: this.product.id, params: { is_recommended: val } })
        await this.$message.success('Статус успешно изменен')
      } catch (e) {
        await this.$message.error('Статус изменить не удалось')
        this.product.is_recommended = !val
      }
    },

    addImage ({ isEdited, images }) {
      if (isEdited) {
        this.form.images = images
      }
    },

    toggleEditMode () {
      this.editMode = !this.editMode
    },

    async changePosition (val) {
      const oldValue = val
      this.product.position = val

      try {
        await this.changeProductPosition({ id: this.product.id, params: { position: val } })
        await this.$message.success('Позиция успешно изменена')
      } catch (e) {
        await this.$message.error('Позицию изменить не удалось')
        this.product.position = oldValue
      }
    },
    async getCities () {
      this.cityOptions = await this.preloadCities()
    },

    selectedCityChange () {
      this.saveProductCity({ productId: this.productId, cityId: this.selectedCityId })
    },

    async getCity (query) {
      if (query !== '') {
        this.cityOptions = await this.fetchCities({ search: query })
      }
    },

    onTopicsChange () {
      this.saveProductTopics({
        productId: this.productId,
        topics: this.form.topics,
      })
    },
    onAttributeChange () {
      // this.saveAttributes({
      //   productId: this.productId,
      //   attributes: this.form.attributes,
      // })
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/_variables"

.wish-info-label
  margin-bottom: 10px
  font-weight: bold

.wish-info-wrapper
  display: flex

  > *
    margin-right: 50px

.panel--mb
  margin-bottom: 25px

.comparing-table__label
  margin-bottom: 4px
  font-weight: 600

.additional-categories
  display: flex
  align-items: center

.additional-categories__block
  width: 100%
  margin-right: 10px

.additional-categories__list
  display: flex
  padding: 10px
  gap: 10px
  width: 70vw

.custom-dialog
  text-align: center

.dialog-content
  display: flex
  flex-direction: column
  align-items: center
  gap: 15px

.message
  font-size: 18px
  line-height: 1.4
  max-width: 100%
  margin: 0
  word-break: keep-all
  overflow-wrap: break-word
  hyphens: auto

.link
  display: block
  margin-top: 10px

.replace-button
  margin-top: 10px

.position-input
  max-width: 120px

.form-container
  display: flex
  flex-direction: column
  gap: 20px

.form-columns
  display: grid
  grid-template-columns: 1fr 1fr
  gap: 30px

.form-column
  display: flex
  flex-direction: column
  gap: 20px

.form-field
  display: flex
  flex-direction: column
  gap: 8px

.form-field.full-width
  grid-column: 1 / -1
  margin-top: 20px

.field-label
  font-weight: 600
  color: #303133
  font-size: 14px
</style>
